import { NAME } from './constants';

export const ENABLE_AUTO_SCROLL = `${NAME}/enableAutoScroll`;
export const DISABLE_AUTO_SCROLL = `${NAME}/disableAutoScroll`;
